import Button from 'components/common/Buttons/index';
import HeroTrastpilot from 'components/Sections/Hero/HeroTrastpilot';
import HeroCrumbs from 'components/Sections/Hero/HeroCrumbs';
import { scrollToSection } from 'helpers';
import { useAnimationWithWithoutScroll } from 'hooks/useAnimation';
import { useRef } from 'react';




const HeroComponent = ({ title,
    desc,
    button_text,
    button_two_text,
    button_text_link,
    button_two_text_link,
    hasCrumbs,
    isLoading }) => {

    const container = useRef();

    const handleClick = () => {
        scrollToSection("product-price")
    }

    useAnimationWithWithoutScroll({
        item: '.hero-body',
        container,
        dependencies: [isLoading],
        isLoading: isLoading
    })
    useAnimationWithWithoutScroll({
        item: '.hero-trastpilot',
        container,
        dependencies: [isLoading],
        isLoading: isLoading
    })
    useAnimationWithWithoutScroll({
        item: '.hero-body-buttons',
        container,
        dependencies: [isLoading],
        isLoading: isLoading
    })
    return (
        <div ref={container} className={`hero-container ${hasCrumbs ? "hero-container--with-crumbs" : ""}`}>
            {hasCrumbs && <HeroCrumbs page={title} />}
            <HeroTrastpilot />
            <div className='hero-body'>
                <h1>{title}</h1>
                <div className='body1'>{desc}</div>
            </div>
            <div className='hero-body-buttons'>
                <Button text={button_text} forPopup={true} />
                <Button text={button_two_text} to={button_two_text_link} type='outline' hasArrow={false} onClick={handleClick} />
            </div>
        </div>
    )
}

export default HeroComponent;